export const isElementInView = (element: Element) => {
  const { top, left, height, width } = element.getBoundingClientRect();
  return top > -height && top < window.innerHeight && left > -width && left < window.innerWidth;
};
